module.exports = __webpack_public_path__ + "static/media/foyer_3.b67d2c25.jpg";